import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class LockInNoticePeriod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lockIn: this.props.lockIn,
      lockInOccupier: this.props.lockInOccupier,
    };
  }

  render() {
    return (
      <div>
        <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
          <div className="row tabForm">
            {this.state.lockIn.lockInApplicableForLandlord == "yes" ? (
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Lock In Period For Landlord (MM-DD) Effective From
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {this.state.lockIn.lockInPeriodLandlord}
                          {`-`}
                          {this.state.lockIn.lockInPeriodLandlordMM}
                          {`-`}
                          {this.state.lockIn.lockInPeriodLandlordDD}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Lock In Period Landlord Start Date
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {leaseDateFormat(
                            this.state.lockIn.lockInPeriodLandlordStartDate
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Lock In Period Landlord End Date
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {leaseDateFormat(
                            this.state.lockIn.lockInPeriodLandlordEndDate
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h6 className="text-center" style={{ padding: "15px" }}>
                      Lock In Not Applicable for Landlord
                    </h6>
                  </div>
                </div>
              </div>
            )}
            {this.state.lockIn.lockInApplicableForOccupier == "yes" ? (
              this.state.lockInOccupier.map(function (name, index) {
                return (
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Lock In Period For Occupier (MM-DD) Effective From
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.lockInPeriod}
                            {`-`}
                            {name.lockInPeriodMM}
                            {`-`}
                            {name.lockInPeriodDD}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Lock In From Date (For Occupier)
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {leaseDateFormat(name.lockInFromDate)}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Lock In End Date (For Occupier)
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {leaseDateFormat(name.lockInEndDate)}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }, this)
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h6 className="text-center" style={{ padding: "15px" }}>
                      Lock In Not Applicable for Occupier
                    </h6>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
          <div className="row tabForm">
            {this.state.lockIn.lockInApplicableForLandlord == "yes" ||
            this.state.lockIn.lockInApplicableForOccupier == "yes" ? (
              <div className="row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Termination Notice Period (MM-DD)
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.state.lockIn.terminationNoticePeriodMM}
                        {`-`}
                        {this.state.lockIn.terminationNoticePeriodDD}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Termination Notice Period (Logic)
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.state.lockIn.terminationNoticePeriodLogic}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Termination Clause
                        <span className="astrik"></span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.state.lockIn.terminationClause}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label
                    className="col-sm-4 col-form-label"
                    style={{ fontSize: "13px", fontWeight: "600" }}
                  >
                    Notes
                    <span className="astrik">*</span>
                  </label>
                  <label
                    className="col-sm-7 col-form-label"
                    style={{ fontSize: "13px", fontWeight: "600" }}
                  >
                    {this.props.lockInNotes}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LockInNoticePeriod);
